import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Table,
} from 'antd';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import IntlMessage from '../../components/IntlMessage';
import { orderStatus } from './order_status.type';
import { paymentStatus } from './payment.type';
import { useIntl } from 'react-intl';
import busOrdersApi from '../../api/bus_orders';
import CountryData from '../../utils/countrydata';

const { Option } = Select;
const { Column } = Table;
const EditBusOrder = (props) => {
  const {
    isModalBookingStatus,
    setIsModalBookingStatus,
    onCloseModalBookingStatus,
    currentData,
    onRefresh,
  } = props;
  const [form] = Form.useForm();
  const intl = useIntl();
  let initialValues = {
    ...currentData,
    pay_status: currentData?.pay_status ?? null,
    order_status: currentData?.order_status ?? '',
    phone_code: currentData?.phone_code ?? '+221',
  };
  const handleOk = async () => {
    form
      .validateFields()
      .then(async (values) => {
        console.log('values', values);
        Promise.all([
          busOrdersApi.editOrder(currentData?.id, {
            pay_status: values.pay_status,
            order_status: values.order_status,
            passengers: values.passengers,
          }),
        ])
          .then((res) => {
            message.success('Updated successfully');
            setIsModalBookingStatus(false);
            onRefresh();
          })
          .catch((error) => {
            // setIsModalBookingStatus(false);

            throw new Error('Update failed');
          });
      })
      .catch((info) => {
        console.log('Validate Failed:1', info);
        message.error(info?.data?.message || 'Update failed');
      });
  };

  const onChangePayStatus = (e) => {};

  const onChangeOrderStatus = (e) => {};

  useEffect(() => {
    form.resetFields();
  }, [form]);

  return (
    <Modal
      title={<IntlMessage id="global.edit" />}
      open={isModalBookingStatus}
      destroyOnClose={true}
      onCancel={onCloseModalBookingStatus}
      width={'80%'}
      onOk={onCloseModalBookingStatus}
      footer={[
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          // loading={loading}
          onClick={handleOk}>
          {<IntlMessage id="global.ok" />}
        </Button>,
      ]}>
      <Form
        // labelCol={{
        //   span: 4,
        // }}
        // wrapperCol={{
        //   span: 12,
        // }}
        initialValues={initialValues}
        labelAlign="left"
        form={form}
        name="control-hooks">
        <>
          <Form.Item
            label={<IntlMessage id="global.order_status" />}
            name="order_status">
            <Select
              showSearch
              onChange={onChangeOrderStatus}
              filterOption={false}
              style={{ width: '200px' }}
              placeholder={intl.formatMessage({
                id: 'orders.order_status',
              })}>
              {orderStatus.map((item, index) => {
                return (
                  <Option value={item.value} key={index}>
                    {item.label}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.pay_status" />}
            name="pay_status">
            <Select
              showSearch
              onChange={onChangePayStatus}
              filterOption={false}
              style={{ width: '200px' }}
              placeholder={intl.formatMessage({
                id: 'global.payment_status',
              })}>
              {paymentStatus.map((item, index) => {
                return (
                  <Option value={item.value} key={index}>
                    {item.label}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Table
            dataSource={currentData.passengers}
            pagination={false}
            rowKey={(item, index) => index}>
            <Column
              title={<IntlMessage id="global.firstname" />}
              key="firstname"
              render={(_, __, index) => (
                <Form.Item
                  name={['passengers', index, 'firstname']}
                  rules={[
                    {
                      required: true,
                      message: <IntlMessage id="global.requiredfield" />,
                    },
                  ]}>
                  <Input style={{ width: '100%' }} />
                </Form.Item>
              )}
            />
            <Column
              title={<IntlMessage id="global.lastname" />}
              key="lastname"
              render={(_, __, index) => (
                <Form.Item
                  name={['passengers', index, 'lastname']}
                  style={{ width: '200px' }}
                  rules={[
                    {
                      required: true,
                      message: <IntlMessage id="global.requiredfield" />,
                    },
                  ]}>
                  <Input style={{ width: '100%' }} />
                </Form.Item>
              )}
            />
            <Column
              title={<IntlMessage id="global.passport" />}
              key="passport"
              render={(_, __, index) => (
                <Form.Item
                  name={['passengers', index, 'passport']}
                  rules={[
                    {
                      required: true,
                      message: <IntlMessage id="global.requiredfield" />,
                    },
                  ]}>
                  <Input style={{ width: '100%' }} />
                </Form.Item>
              )}
            />
            <Column
              title={<IntlMessage id="global.phone" />}
              key="phone"
              render={(_, __, index) => (
                <Form.Item
                  name={['passengers', index, 'phone']}
                  rules={[
                    {
                      required: true,
                      message: <IntlMessage id="global.requiredfield" />,
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: <IntlMessage id="global.numberfield" />,
                    },
                  ]}>
                  <Input style={{ width: '100%' }} />
                </Form.Item>
              )}
            />
            <Column
              render={(_, __, index) => (
                <Form.Item name={['passengers', index, 'id']} hidden>
                  <Input />
                </Form.Item>
              )}
            />
          </Table>
        </>
      </Form>
    </Modal>
  );
};

export default EditBusOrder;
